import { Component, inject, Input, OnInit, signal, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAdminEvent, selectAdminUser, selectEventBooking } from '../../../../../data-services/stores/selectors/admin.selectors';
import { ActivatedRoute } from '@angular/router';
import { AdminBoilerplateComponent } from '../../../../../core/admin-boilerplate/feature/admin-boilerplate.component';
import { CommonModule } from '@angular/common';
import { HeadlineComponent } from '../../../../../events/headline/feature/headline.component';
import { adminActions } from '../../../../../data-services/stores/actions/admin.actions';
import { TicketPillComponent } from '../../../../../events/book/ticket-pill/feature/ticket-pill.component';
import { EventTicketBasic } from '../../../../../data-services/models/event-tickets/event-ticket-basic.model';
import { DividerComponent } from "../../../../../core/divider/feature/divider.component";
import { Observable, tap } from 'rxjs';
import { UserComplete } from '../../../../../data-services/models/account/user-complete.model';
import { EventSystemActions } from '../../../../../data-services/stores/actions/event-system.actions';
import { selectEventSystem } from '../../../../../data-services/stores/selectors/event-systems.selectors';
import { EventSystemComplete } from '../../../../../data-services/models/event-systems/event-system-complete.model';

@Component({
  selector: 'app-admin-edit-booking',
  imports: [AdminBoilerplateComponent, HeadlineComponent, CommonModule, TicketPillComponent, DividerComponent],
  templateUrl: '../ui/edit-booking.component.html',
  styleUrl: '../ui/edit-booking.component.css'
})
export class AdminEditBookingComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  event$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"])).pipe(
    tap(event => {
      if (event) {
        this._store.dispatch(EventSystemActions.getSingleEventSystem({ systemRef: event.eventHost.eventSystem.systemRef }))
        this._store.select(selectEventSystem(event.eventHost.eventSystem.systemRef)).subscribe(res => {
          if (res) {
            this.eventSystem = res as EventSystemComplete
          }
        })
      }
    })
  )
  eventBooking$ = this._store.select(selectEventBooking(this._route.snapshot.params["bookingId"])).pipe(
    tap(booking =>{
      if (booking){
        this._store.dispatch(adminActions.getSingleUser({ userId: booking.accountID }))
      }
    })
  )
  user$: Observable<UserComplete> | undefined;
  eventSystem?: EventSystemComplete;
  user?: UserComplete;

  ngOnInit(): void {
    this._store.dispatch(adminActions.getEvent({ eventRef: this._route.snapshot.params["id"] }));
    this._store.dispatch(adminActions.getEventBooking({ eventRef: this._route.snapshot.params["id"], bookingId: this._route.snapshot.params["bookingId"]}))
  }

  getPrimaryTicket(tickets: EventTicketBasic[]):EventTicketBasic | undefined {
    return tickets.find(x => ['Player','Player (Under 16)','Crew','Crew (Under 16)','Staff'].includes(x.name))
  }

  getAdditionalTicket(tickets: EventTicketBasic[]):EventTicketBasic[] | undefined {
    return tickets.filter(x => !['Player','Player (Under 16)','Crew','Crew (Under 16)','Staff'].includes(x.name))
  }

  getCustomFields(section: "player" | "character") {
    return this.eventSystem?.customFields?.filter(x => x.section === section)
  }

  getCustomFieldValue(id: number) {
    return this.user?.customFields?.find(x => x.customField?.id === id)
  }
}

@Component({
  selector: 'app-admin-new-booking',
  imports: [],
  templateUrl: '../ui/add-booking.component.html',
  styleUrl: '../ui/edit-booking.component.css'
})
export class AdminAddBookingComponent {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  event$ = this._store.select(selectAdminEvent(this._route.snapshot.params["id"]));

}
